
import {geSpecification} from "@/utils/product";
export const mixins = {
  methods: {
    // 参数对比值添加
  // id： 参数id可以进行去重
  joinCompare(row) {
    let lostCompare = JSON.parse(localStorage.getItem('vuex'))
    // let list = this.$store.state.compare;
    let list = JSON.parse(localStorage.getItem('lostCompare'));
    let listShow = true
    // console.log("lojfsjfjas", lostCompare)
    if(list.length > 9) {
        this.$message({
          message: '对比数据不得超过十条',
          type: 'warning'
        });
      }else {
        if(list.length > 0) {
          list.map(item => {
            if(item.uuid == row.uuid) {
              this.$message({
                message: '此产品已存在对比列表中',
                type: 'warning'
              });
              listShow = false
            }
          })
        } 
        if(listShow) {
          geSpecification(row.uuid).then((res) => {
            if(res.success) {
              list.push(res.data)
              // console.log(333333, list)
              this.$store.commit('compareVuex', list)
              lostCompare.compare = list
              localStorage.setItem('lostCompare', JSON.stringify(list));
            }
          });
        }
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/product/mixin/index.js